import { FormFieldConfig } from '../types'
import { Field } from '@components/gassan-ui'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'

type MessageFieldProps = {
  willAttend: boolean
  field: FormFieldConfig
}

export const MessageField: FC<MessageFieldProps> = ({ willAttend, field }) => {
  const { t } = useTranslation('forms')

  const getLabel = (): string => {
    const isMandatory = field.mandatory ?? false

    return !willAttend || isMandatory
      ? t('labels.messageAppointment')
      : `${t('labels.messageAppointment')} - ${t('optional', { ns: 'forms' })}`
  }

  return <Field name="message" label={getLabel()} field="textarea" gridColumn="span 12" />
}
